import { ChangePassword } from "interfaces/EmployeVerification";
import { patch, post } from "services/services.methods";
import { EmployeVerificationPaths } from "services/services.paths";

export const getOtp = async (email: string) => {
  const response = await post<any>(EmployeVerificationPaths.generateOtp, {
    email: email,
  });

  return response;
};

export const changePassword = async (payload: ChangePassword) => {
  const response = await patch<any>(
    EmployeVerificationPaths.changePassword,
    payload
  );

  return response;
};

export const unlockUserService = async (email: string) => {
  const response = await patch<any>(EmployeVerificationPaths.unlockUser, {
    email: email,
  });

  return response;
};
